import React, { useState } from "react";
import { useParams } from 'react-router-dom';
import Header from './components/Header';
// If this file uses any CSS modules, update the import

export default function Refresh() {
  const { connectedAccountId } = useParams();
  const [accountLinkCreatePending, setAccountLinkCreatePending] = useState(false);
  const [error, setError] = useState(false);

  React.useEffect(() => {
    if (connectedAccountId) {
      setAccountLinkCreatePending(true);
      fetch("/account-link", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          accountId: connectedAccountId,
        }),
      })
        .then((response) => response.json())
        .then((json) => {
          setAccountLinkCreatePending(false);

          const { url, error } = json;

          if (url) {
            window.location.href = url;
          }

          if (error) {
            setError(true);
          }
        });
    }
  }, [connectedAccountId])

  return (
    <div className="container">
      <Header title="Account Setup" />
      <div className="content">
        <h2>Complete Your Account Setup</h2>
        <p>Please provide the required information to start accepting payments for your restaurant.</p>
        {error && <p className="error">Something went wrong!</p>}
      </div>
      <div className="dev-callout">
        {connectedAccountId && <p>Account ID: <code className="bold">{connectedAccountId}</code></p>}
        {accountLinkCreatePending && <p>Creating account link...</p>}
      </div>
    </div>
  );
}